export const PARCEL_HEATMAP_REPORTS = {
  'PARCEL VOLUME': {
    tableName: 'REPORT.PARCEL_VOLUME',
    demoReportName: 'REPORT.DEMO_PARCEL_VOLUME',
  },
  'PARCEL TOTAL COST': {
    tableName: 'REPORT.PARCEL_TOTAL_COST',
    demoReportName: 'REPORT.DEMO_PARCEL_TOTAL_COST',
  },
  'PARCEL AVERAGE COST': {
    tableName: 'REPORT.PARCEL_AVERAGE_COST',
    demoReportName: 'REPORT.DEMO_PARCEL_AVERAGE_COST',
  },
  'PARCEL TRANSIT DAYS': {
    tableName: 'REPORT.PARCEL_TRANSIT_DAYS',
    demoReportName: 'REPORT.DEMO_PARCEL_TRANSIT_DAYS',
  },
};

export const getParcelHeatmapReportConfig = reportType => (
  PARCEL_HEATMAP_REPORTS[reportType] || null
);
